import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { WorkflowUserApproverModel } from '../../models/workflow/workflow-order.model';

const BASE = `${environment.backend.url}/api/workflow/orders/v1`;

@Injectable({ providedIn: 'root' })
export class WorkflowOrderService {
  constructor(private readonly http: HttpClient) {}

  /** GET - Query active workflow for an order. Returns 404 if none. */
  query(orderId: string): Observable<WorkflowUserApproverModel> {
    return this.http.get<WorkflowUserApproverModel>(
      `${BASE}/query/${encodeURIComponent(orderId)}`
    );
  }

  /** POST - Create new workflow. referenceId = orderId. */
  create(referenceId: string): Observable<WorkflowUserApproverModel> {
    return this.http.post<WorkflowUserApproverModel>(`${BASE}/create`, {
      referenceId,
    });
  }

  /** POST - Submit approve or deny feedback. feedbackMessage is required. */
  feedback(
    workflowId: number,
    approved: boolean,
    feedbackMessage: string
  ): Observable<WorkflowUserApproverModel> {
    return this.http.post<WorkflowUserApproverModel>(`${BASE}/feedback`, {
      workflowId,
      approved,
      feedbackMessage,
    });
  }

  /** DELETE - Cancel active workflow. */
  cancel(workflowId: number): Observable<void> {
    return this.http.delete<void>(`${BASE}/cancel/${workflowId}`);
  }

  /** POST - Recompile workflow when users changed. */
  recompile(referenceId: string): Observable<WorkflowUserApproverModel> {
    return this.http.post<WorkflowUserApproverModel>(`${BASE}/recompile`, {
      referenceId,
    });
  }
}
